export const createUserDraftCopyOfVersion = 'createUserDraftCopyOfVersion';
